module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-131.850266d.woff2";